module.exports = __webpack_public_path__ + "static/assets/5262c771a2cef6dcd0a80d209abc8201.png";